import { Box, Button, Grid, Icon, IconButton, Stack, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { resetCreditData } from '../../../../store/features/loans/loans.slice';
import { useTypedSelector } from '../../../../store/hooks';
import { CreditCredentials } from '../../utils';
import langFile from '../../../../data/lang.json';

interface CredentialsFormProps {
    results: React.ReactNode;
    onSubmit: (data: CreditCredentials) => void;
}

const CredentialsForm: React.FC<CredentialsFormProps> = (props) => {
    const dispatch = useDispatch();
    const {
        initialFee,
        amount,
        percent,
        period,
        daysInMonth,
        daysInYear,
        annuity,
        differentiated,
    } = useTypedSelector(state => state.loans);
    const { lang } = useTypedSelector(state => state.common);
    const [settings, setSettings] = useState<boolean>(false);

    const defaultValues: CreditCredentials = {
        daysInMonth,
        daysInYear,
        initialFee,
        amount,
        period,
        percent
    }

    const { control, handleSubmit } = useForm({ defaultValues });

    const onSubmit = (data: CreditCredentials) => props.onSubmit(data);

    return (
        <Box 
            sx={{
                py: 2
            }}
            component="form"
            onSubmit={handleSubmit(onSubmit)}>
            
            

            <Grid container spacing={2}>
                <Grid 
                    item
                    xs={12}
                    sm={6}>
                    <Stack sx={{ pb: 1 }} direction="row" justifyContent="flex-end">
                        <IconButton 
                            onClick={() => setSettings(!settings)}
                            size="small">
                            <Icon>settings</Icon>
                        </IconButton>
                    </Stack>

                    <Stack 
                        gap={2}>

                        {settings &&
                            <Stack direction="row" gap={2}>
                            
                                    <Controller
                                        name="daysInMonth"
                                        control={control}
                                        render={({ field }) => 
                                        <TextField 
                                            {...field}
                                            fullWidth
                                            type="number"
                                            size="small"
                                            label={(langFile.daysInMonth as any)[lang]} 
                                            variant="filled" />
                                    }
                                    />
                                
                                    <Controller
                                        name="daysInYear"
                                        control={control}
                                        render={({ field }) => 
                                        <TextField 
                                            {...field}
                                            fullWidth
                                            type="number"
                                            size="small"
                                            label={(langFile.daysInYear as any)[lang]} 
                                            variant="filled" />
                                    }
                                    />
                            
                            </Stack>
                        }

                        {/* <Controller
                            name="initialFee"
                            control={control}
                            render={({ field }) => 
                            <TextField 
                                {...field}
                                type="number"
                                size="small"
                                label="Первоначальный взнос" 
                                variant="filled" />
                        }
                        /> */}
                        <Controller
                            name="amount"
                            control={control}
                            render={({ field }) => 
                            <TextField 
                                {...field}
                                type="number"
                                size="small"
                                label={(langFile.loanAmount as any)[lang]} 
                                variant="filled" />
                        }
                        />
                        <Controller
                            name="period"
                            control={control}
                            render={({ field }) => 
                            <TextField 
                                {...field}
                                type="number"
                                size="small"
                                label={(langFile.period as any)[lang]}
                                variant="filled" />
                        }
                        />
                        <Controller
                            name="percent"
                            control={control}
                            render={({ field }) => 
                            <TextField 
                                {...field}
                                type="number"
                                size="small"
                                label={(langFile.interestRate as any)[lang]} 
                                variant="filled" />
                        }
                        />

                        <Button
                            type="submit"
                            disableElevation
                            variant="contained">{(langFile.calculateBtn as any)[lang]}</Button>

                        <Button
                            type="reset"
                            disableElevation
                            onClick={() => dispatch(resetCreditData())}>{(langFile.resetBtn as any)[lang]}</Button>
                        

                    </Stack>
                </Grid>
                <Grid 
                    item
                    xs={12}
                    sm={6}>
                    {props.results}
                </Grid>
            </Grid>

        </Box>
    )
}

export default CredentialsForm;